// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bomTableProductCardStyles } from "@stoneage/App/Components/ProductDetails/BomTableProductCard";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

const generalCellStyle = css`
    &,
    span {
        font-size: 14px;
        line-height: 22px;
    }
    &&&& a span {
        font-weight: bold;
        color: ${color("common.black")};
    }
`;

bomTableProductCardStyles.cellStyle = {
    css: css`
        ${generalCellStyle}
    `,
};
bomTableProductCardStyles.descriptionCellStyle = {
    css: css`
        ${generalCellStyle}
        ${xScreen("gt", "md")} {
            max-width: 335px;
            width: 335px;
            white-space: normal;
        }
    `,
};
bomTableProductCardStyles.partNumberCellStyle = {
    css: css`
        ${generalCellStyle}
        ${xScreen("gt", "md")} {
            max-width: 205px;
            width: 205px;
            white-space: normal;
        }
    `,
};
bomTableProductCardStyles.sortOrderCellStyle = {
    css: css`
        ${generalCellStyle}
        ${xScreen("gt", "md")} {
            max-width: 65px;
            width: 65px;
        }
    `,
};
bomTableProductCardStyles.costStyles = {
    price: {
        priceText: {
            size: 14,
            color: "text.main",
            weight: "normal",
            lineHeight: "22px",
        },
    },
};

bomTableProductCardStyles.centeringWrapper = {
    css: css`
        height: 100px;
        display: flex;
        align-items: center;
    `,
};
bomTableProductCardStyles.spinner = {
    css: css`
        margin: auto;
    `,
};
bomTableProductCardStyles.configureText = {
    size: 12,
    lineHeight: "18px",
    weight: "bold",
    color: "common.black",
    css: css`
        margin-right: 4px;
    `,
};
bomTableProductCardStyles.icon = {
    css: css`
        opacity: 0.33;
    `,
};
bomTableProductCardStyles.expandIconWrapper = {
    css: css`
        cursor: pointer;
    `,
};
bomTableProductCardStyles.headingRow = {
    css: css`
        &&& {
            border: none;
            background: ${color("common.ui3")};
            ${xScreen("lte", "md")} {
                display: none;
            }
        }
    `,
};
bomTableProductCardStyles.childrenHeaderCell = {
    css: css`
        &,
        span {
            font-size: 12px;
            font-weight: bold;
            line-height: 18px;
            color: ${color("text.main")};
        }
    `,
};
